









































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
// types
import { ApplicationSettings } from "@/services/applicationSettings/types";
// service methods
import {
    getAllApplicationSettings,
    updateApplicationSettings
} from "@/services/applicationSettings/applicationSettingsService";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import { Action } from "vuex-class";

@Component<Settings>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        HeaderActionButtons,
        UnsavedFormModal
    }
})
export default class Settings extends Vue {
    @Action("loadAzureAdStatus") loadAzureAdStatus: any;
    @Action("logger/updateLogLevels") updateLogLevels: any;
    @Action("loadAllowStockImages") loadAllowStockImages: any;

    // local state
    applicationSettings = {
        maxUploadFileSize: "",
        allowedImageExtensions: "",
        allowedVideoExtensions: "",
        otherAllowedExtensions: "",
        azureAppClientId: "",
        clientTenantId: "",
        adminUserGroupId: "",
        editorUserGroupId: "",
        enableCustomerSSO: false,
        clearUserData: false,
        numberOfInactivityDays: 0,
        distinguishPersonalDataPosts: false,
        postValidDays: 730,
        personalDataPostValidDays: 0,
        logLevels: "",
        allowStockImages: false
    } as ApplicationSettings;

    // used for comparing if form have changes
    localApplicationSettings = {
        maxUploadFileSize: "",
        allowedImageExtensions: "",
        allowedVideoExtensions: "",
        otherAllowedExtensions: "",
        azureAppClientId: "",
        clientTenantId: "",
        adminUserGroupId: "",
        editorUserGroupId: "",
        enableCustomerSSO: false,
        clearUserData: false,
        numberOfInactivityDays: 0,
        distinguishPersonalDataPosts: false,
        postValidDays: 0,
        personalDataPostValidDays: 0,
        logLevels: "",
        allowStockImages: false
    } as ApplicationSettings;

    nextRoute = "";
    routeParams = {};
    saveClicked = false;
    logLevelOptions = ["error", "information", "debug"];
    logLevelsSelected = [] as string[];
    // lifecycle hooks
    public created(): void {
        this.fetchData();
    }

    // methods
    save(back: boolean) {
        this.saveClicked = true;
        this.applicationSettings.logLevels = this.logLevelsSelected.join(", ");
        updateApplicationSettings(this.applicationSettings).then(() => {
            this.loadAzureAdStatus();
            this.updateLogLevels(this.applicationSettings.logLevels);
            this.loadAllowStockImages();
            if (back) this.$router.push("/");
        });
    }

    back() {
        window.history.go(-1);
    }

    fetchData() {
        getAllApplicationSettings().then(response => {
            this.applicationSettings = {
                maxUploadFileSize: response.maxUploadFileSize || "",
                allowedImageExtensions: response.allowedImageExtensions || "",
                allowedVideoExtensions: response.allowedVideoExtensions || "",
                otherAllowedExtensions: response.otherAllowedExtensions || "",
                azureAppClientId: response.azureAppClientId || "",
                clientTenantId: response.clientTenantId || "",
                adminUserGroupId: response.adminUserGroupId || "",
                editorUserGroupId: response.editorUserGroupId || "",
                enableCustomerSSO: response.enableCustomerSSO || false,
                clearUserData: response.clearUserData || false,
                numberOfInactivityDays: response.numberOfInactivityDays || 0,
                distinguishPersonalDataPosts: response.distinguishPersonalDataPosts,
                postValidDays: response.postValidDays || 730,
                personalDataPostValidDays: response.personalDataPostValidDays || 0,
                wayfinderInstanceId: response.wayfinderInstanceId,
                logLevels: response.logLevels || "",
                allowStockImages: response.allowStockImages || false
            };
            this.localApplicationSettings = JSON.parse(JSON.stringify(this.applicationSettings));

            if (this.applicationSettings.logLevels && this.applicationSettings.logLevels.length > 1) {
                this.logLevelsSelected = this.applicationSettings.logLevels.split(", ");
            }
        });
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.nextRoute === "" && !this.saveClicked) {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            JSON.stringify(this.localApplicationSettings) === JSON.stringify(this.applicationSettings) ? next() : (this.$refs.UnsavedFormModal as any).open();
        } else {
            next();
        }
    }

    onContinue(data: boolean) {
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }
}
